import { List } from 'immutable'
import {
  AsyncState,
  Updater,
  loadedAsyncState,
  loadingAsyncState
} from 'widgets-for-react'
import { headerApi, utilitesApi } from './headerApi'
import { initialTranslateState } from '../automaticTranslator/translateState'

export type HeaderState = {
  menuOpened: boolean
  headerItemsState: AsyncState<List<HeaderItem>>
  utilityItemsState: AsyncState<List<UtilityItem>>
  translateState: {
    isTranslateModalOpen: boolean
    isTranslateBannerVisible: boolean
  }
}

export type HeaderItem = {
  opened: boolean
  title: string
  url: string
  children: {
    title: string
    url: string
  }[]
}

export type UtilityItem = {
  title: string
  url: string
}

export const initialHeaderState: HeaderState = {
  menuOpened: false,
  headerItemsState: loadingAsyncState(headerApi),
  utilityItemsState: loadingAsyncState(utilitesApi),
  translateState: initialTranslateState
}

export const headerStateUpdaters = {
  updateHeaderDataState: (updater: Updater<AsyncState<List<HeaderItem>>>) => (
    currentState: HeaderState
  ): HeaderState => ({
    ...currentState,
    headerItemsState: updater(currentState.headerItemsState)
  }),
  updateMenuOpened: (currentState: HeaderState): HeaderState => ({
    ...currentState,
    menuOpened: !currentState.menuOpened
  }),
  updateItemOpened: (index: number) => (
    currentState: HeaderState
  ): HeaderState => {
    if (currentState.headerItemsState.kind === 'loaded') {
      const item = currentState.headerItemsState.value.get(index)
      if (item == undefined) return currentState
      else
        return {
          ...currentState,
          headerItemsState: loadedAsyncState<List<HeaderItem>>(
            currentState.headerItemsState.value.map((item, i) => ({
              ...item,
              opened: i === index ? !item.opened : false
            }))
          )
        }
    } else return currentState
  },
  updateUtilityDataState: (updater: Updater<AsyncState<List<UtilityItem>>>) => (
    currentState: HeaderState
  ): HeaderState => ({
    ...currentState,
    utilityItemsState: updater(currentState.utilityItemsState)
  })
}
